import { CANCEL_LABEL } from '../../constants/endpoints';

export default (browserFingerprint) =>
  async ({ retailer: retailerName, encrypted_return_id: encryptedReturnId }) => {
    try {
      const response = await fetch(
        CANCEL_LABEL({
          retailerName,
          encryptedReturnId,
        }),
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'narvar-tfid': browserFingerprint,
          },
        },
      );

      const { error: { error_message: errorMessage } = {} } = await response.json();

      if (errorMessage) throw new Error(errorMessage);

      return true;
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }

    return false;
  };
